@if (inPresentationMode) {
    <ddv-dashboard-name-view
        [dashboard]="dashboard"
        [group]="memberOf"
        [entitlements]="userEntitlements"
        [sharing]="sharing"
        (dashboardSwitch)="dashboardSwitch.emit($event)"
        (switchToEditMode)="editAction.emit('edit')"
    >
    </ddv-dashboard-name-view>
} @else {
    <ddv-dashboard-name-edit
        [dashboard]="dashboard"
        [group]="memberOf"
        [isDirty]="isDirty"
        (dashboardSwitch)="dashboardSwitch.emit($event)"
        (editAction)="editAction.emit($event)"
    >
    </ddv-dashboard-name-edit>
}
